import { render, staticRenderFns } from "./EstHistCifras.vue?vue&type=template&id=d281a346&"
import script from "./EstHistCifras.vue?vue&type=script&lang=js&"
export * from "./EstHistCifras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports